module.exports = __webpack_public_path__ + "static/media/23120202_1638429989565519_3884776797891802890_o-thumb.a88afcce.jpg";